module.exports = __webpack_public_path__ + "img/market_insight_privacy.b73e101c.jpg";